import * as React from 'react';
import { Component } from 'react';
import { Field, Form, getFormValues, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { __ } from '../../core/utils';
import { subscribe } from 'react-contextual';
import Localization from '../../helpers/Localization';
import { enableAutosave } from '../../redux/actions/general/autosave';
import { withRouter } from 'react-router';
import Input from '../../components/Input';
import Select from '../../components/Select';
import DateTimePicker from '../../components/DateTimePicker';

const mapStateToProps = (state) => {
  return {
    values: getFormValues('company_holidays.details')(state),
  };
};

@reduxForm({
  form: 'company_holidays.details',
  enableReinitialize: true,
})
@subscribe(Localization, 'localization')
@connect(mapStateToProps)
@withRouter
class EditCompanyHolidayForm extends Component {
  constructor(props) {
    super(props);
  }

  UNSAFE_componentWillReceiveProps() {
    enableAutosave(this.props.form);
  }

  componentDidMount() {}

  render() {
    const countries = _.map(this.props.localization.countries, (country) => {
      return {
        value: country.id,
        label: country.name,
      };
    });

    return (
      <Form onSubmit={this.props.handleSubmit}>
        <Field
          name='country_id'
          component={Select}
          label={__('edit-company-holidays-form.country')}
          options={countries}
          placeholder={__('edit-company-holidays-form.select-country')}
        />
        <Field
          name='name'
          component={Input}
          label={__('edit-company-holidays-form.name')}
        />
        <Field
          name='date'
          component={DateTimePicker}
          label={__('edit-company-holidays-form.date')}
          footer
        />
      </Form>
    );
  }
}

export default EditCompanyHolidayForm;
